export const constant = {
  errorMessage: 'There’s a technical issue on our end. Try again.',
};
